<template>
  <div id="body">
    <div id="logo">
      <a :href="'https://e5ex.com'" style="text-decoration:none;"><img id="img" alt="" src="../assets/toroAppLogo.png"></a>
    </div>
    <div style="font-size: 20px;font-weight:bold;margin: 5px auto 5px;width: 156px"><span style="margin: auto">TORO胎压 1.4.0</span>
    </div>
    <div style="font-weight:bold;width: 300px;margin: 20px auto 20px"><span style="margin: 2px">TORO胎压是一款胎压监测APP，可以实时查看胎压状况，实时异常情况报警，历史轨迹查询以及异常历史记录，让您以全新的方式管理你的爱车，使您出行更安全。</span>
    </div>
    <!--底部栏-->
    <div id="ToolBar"><a :href="'https://portal.e5ex.cn/manual/p1'" style="color: gray">隐私政策</a><br/>
      <h6 style="color: gray">深圳市博尔汽车科技有限公司 版权所有</h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "correlation"
}
</script>

<style scoped>
#img {
  height: 100px;
  width: 100px;
}

#ToolBar {
  position: absolute;
  bottom: 20px;
  width: 100%;
  height: auto;
  text-align: center;
  z-index: 2;
  overflow: hidden;
}

#body {
  height: 100%;
  width: 100%;
  position: absolute;
}

#logo {
  height: 100px;
  width: 100px;
  margin: 50px auto 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/correlation.vue